import { Link } from 'react-router-dom';
import './HeroBookBadge.css';

const COVER_ALT = '『執事のマナーと教養図鑑』(Gakken)全日本執事協会 執事ベル監修の書影';
const COVER_ALT_EN = "Cover image of Gakken's A British Butler's Guide to Manners and Culture, supervised by Butler Bell of the All Japan Butler Association";
const ARIA_LABEL = '『執事のマナーと教養図鑑』(Gakken・全日本執事協会 執事ベル監修)の詳細ページを見る';
const ARIA_LABEL_EN = "See the detail page for Gakken's A British Butler's Guide to Manners and Culture, supervised by Butler Bell of the All Japan Butler Association";
const HEADING = '全日本執事協会 執事ベル監修の書籍';
const HEADING_EN = 'A Book Supervised by Butler Bell of the All Japan Butler Association';
const BOOK_TITLE = '『執事のマナーと教養図鑑』';
const BOOK_TITLE_EN = "A British Butler's Guide to Manners and Culture";
const BOOK_SUBTITLE = '英国紳士の美しい暮らしかた 50 Topics';
const BOOK_SUBTITLE_EN = 'How to Live Elegantly — 50 Topics';
const SUPERVISOR = '全日本執事協会 執事ベル';
const SUPERVISOR_EN = 'Butler Bell, All Japan Butler Association';
const COOPERATOR = '執事喫茶 Swallowtail';
const COOPERATOR_EN = 'Butler Café Swallowtail';
const PUBLISHER = 'Gakken';
const LEAD = '英国執事の所作と教養を、50 の話題でたどる一冊。本書の監修を全日本執事協会 執事ベルが務めました。';
const LEAD_EN = 'Fifty topics that trace the manners and culture of the British butler. Butler Bell of the All Japan Butler Association served as its supervising editor.';
const CTA = '詳しく見る →';
const CTA_EN = 'Read more →';

type HeroBookBadgeProps = {
  lang?: 'ja' | 'en';
};

export default function HeroBookBadge({ lang = 'ja' }: HeroBookBadgeProps) {
  const isEnglish = lang === 'en';
  const headingId = isEnglish ? 'butlerbell-hb-heading-en' : 'butlerbell-hb-heading';
  const localize = (ja: string, en: string) => isEnglish ? en : ja;

  return (
    <section className="butlerbell-hb-section hero-book-badge tb-hb" aria-labelledby={headingId} lang={lang}>
      <p className="tb-hb-kicker">BOOK</p>
      <h2 id={headingId} className="tb-hb-heading">{isEnglish ? HEADING_EN : HEADING}</h2>
      <Link className="tb-hb-link tb-hb-image-link" to={isEnglish ? '/en/book/butler-manners-and-culture' : '/book/butler-manners-and-culture'} aria-label={isEnglish ? ARIA_LABEL_EN : ARIA_LABEL}>
        <picture className="tb-hb-picture">
          <source media="(max-width: 1000px)" srcSet="/images/book/gakken-book-link-sp.png" />
          <img
            className="tb-hb-image"
            src="/images/book/gakken-book-link.png"
            srcSet="/images/book/gakken-book-link.png 1x, /images/book/gakken-book-link@2x.png 2x"
            width="560"
            height="717"
            alt={isEnglish ? COVER_ALT_EN : COVER_ALT}
            loading="eager"
            decoding="async"
          />
        </picture>
        <div className="tb-hb-copy">
          <p className="tb-hb-title">{localize(BOOK_TITLE, BOOK_TITLE_EN)}</p>
          <p className="tb-hb-subtitle">{localize(BOOK_SUBTITLE, BOOK_SUBTITLE_EN)}</p>
          <dl className="tb-hb-meta">
            <div><dt>{localize('監修', 'Supervised by')}</dt><dd>{localize(SUPERVISOR, SUPERVISOR_EN)}</dd></div>
            <div><dt>{localize('協力', 'In cooperation with')}</dt><dd>{localize(COOPERATOR, COOPERATOR_EN)}</dd></div>
            <div className="tb-hb-meta-publisher"><dt>{localize('出版', 'Published by')}</dt><dd>{PUBLISHER}</dd></div>
          </dl>
          <p className="tb-hb-lead">{localize(LEAD, LEAD_EN)}</p>
          <span className="tb-hb-cta">{localize(CTA, CTA_EN)}</span>
        </div>
      </Link>
    </section>
  );
}
